import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceComplete, isResourceLoading } from './common';

const isJobAidsLoading = lruMemoize(isResourceLoading);
const getJobAids = lruMemoize(
    (data) => data.getIn(['job_aids'], List()),
);

const getMonthlyJobAidsData = (state) => state.getIn(['app', 'monthlyJobAids']);
const isMonthlyJobAidsLoading = createSelector(getMonthlyJobAidsData, isResourceLoading);
const getMonthlyJobAids = createSelector(getMonthlyJobAidsData, (data) => data.get('jobAids', List()).toJS());

const getPrelaunchJobAidsData = (state) => state.getIn(['app', 'prelaunchJobAids']);
const isPrelaunchJobAidsLoading = createSelector(getPrelaunchJobAidsData, isResourceLoading);
const getPrelaunchJobAids = createSelector(getPrelaunchJobAidsData, (data) => data.get('jobAids', List()).toJS());

const getJobAidData = (state) => state.getIn(['app', 'training']);
const isJobAidLoaded = createSelector(getJobAidData, isResourceComplete);
const getJobAidTitle = createSelector(getJobAidData, (data) => data.getIn(['jobAid', 'title']));

export {
    isJobAidLoaded,
    isJobAidsLoading,
    isMonthlyJobAidsLoading,
    isPrelaunchJobAidsLoading,
    getJobAids,
    getJobAidTitle,
    getMonthlyJobAids,
    getPrelaunchJobAids,
};
